import React from 'react'
import { Card, Row, Col, Statistic, Space, Typography } from 'antd'
import { useAnalytics } from '../hooks/useAnalytics'
import { KeyMetricsGrid } from '../components/KeyMetricsGrid'
import { RevenueChart } from '../components/RevenueChart'
import { CategoryChart } from '../components/CategoryChart'

const { Title } = Typography

export const AnalyticsScreen: React.FC = () => {
    const { revenueData, categoryData, performance } = useAnalytics()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>

            <KeyMetricsGrid />

            <Row gutter={[16, 16]}>
                <Col xs={24} lg={12}>
                    <RevenueChart data={revenueData} />
                </Col>
                <Col xs={24} lg={12}>
                    <CategoryChart data={categoryData} />
                </Col>
            </Row>

            <Card title="Platform Performance">
                <Row gutter={[16, 16]}>
                    <Col span={8}>
                        <Statistic
                            title="Average Order Value"
                            value={performance.averageOrderValue}
                            prefix="₹"
                            precision={0}
                        />
                    </Col>
                    <Col span={8}>
                        <Statistic
                            title="Conversion Rate"
                            value={performance.conversionRate}
                            suffix="%"
                            precision={1}
                        />
                    </Col>
                    <Col span={8}>
                        <Statistic
                            title="Customer Satisfaction"
                            value={performance.customerSatisfaction}
                            suffix="/ 5"
                            precision={1}
                        />
                    </Col>
                </Row>
            </Card>
        </Space>
    )
}
